import type { VerbTypes } from 'modules/core/lib/verbTypes'

type VerbOption = Record<string, VerbTypes>
type Options = Record<string, VerbOption>

export const getSurveysPermissionVerbs = (): Options => {
  return {
    forms: {
      permission: 'apiCore.accessSurveysCreateForms',
      owned: 'surveys.surveyCreateOwned',
      everybody: 'surveys.surveyCreateEverybody',
      reportees: 'surveys.surveyCreateReportees',
      team: 'surveys.surveyCreateTeam',
    },
    templates: {
      permission: 'apiCore.accessSurveysCreateTemplates',
    },
  }
}
